/* ---------------------------------------------------------------------------
   Längenfinder für Handyketten
   ---------------------------------------------------------------------------
   Die Kundin gibt ihre Größe bei Shirts/Pullis und ihre Körpergröße an (beides
   Pflicht), wir setzen daraufhin die passende LÄNGE. Die Zuordnung selbst steht
   als Schwellen-Tabelle in auswerten() weiter unten.

   🔴 Zwei Betriebsarten, eine Regel (data-modus):
     'pdp'      — Produktseite: setzt das Radio der Längen-Option.
     'beratung' — Story-/Sales-Seite ohne Variantenauswahl: legt den Kurz/Lang-
                  Umschalter der Konfigurator-Karten um und zeigt die Empfehlung.
   Die Regel darf es nur einmal geben; stünde sie an zwei Stellen, würden
   Produktseite und Story-Seite irgendwann Verschiedenes empfehlen.

   🔴 Nur die Länge, nie die ganze Variante. Handyketten haben zwei Optionen:
   `Länge` (Kurz 115 cm / Lang 145 cm) und `Zubehör` (mit/ohne Karabiner und
   Handylasche). Das Zubehör hat die Kundin selbst gewählt — das darf der Finder
   nicht überschreiben. Deshalb wird gezielt ein Radio der Längen-Option gesetzt
   und nicht etwa eine Varianten-ID.

   🔴 Warum data-option-position + value und nicht die Element-ID:
   Prestige baut die IDs als `<form-id>-option<position>-<option_value.id>`, bei
   Swatch- und Thumbnail-Darstellung kommt aber ein `id_prefix` dazu. Über die
   beiden Datenattribute treffen wir das Radio unabhängig von der Darstellungsart.

   Prestige horcht auf `change` bei jedem Input, dessen `name` "option" enthält
   (theme.js, onOptionChanged_fn) und lädt die Section dann selbst neu.

   🔴 Deshalb wandert das Dialogfenster beim ersten Verdrahten nach <body>:
   `variant_picker` steht in der Partial-Rerender-Liste von <product-rerender>,
   der Block wird beim Setzen der Länge also komplett ersetzt. Läge das Fenster
   noch darin, würde es mitten im eigenen Erfolgsmoment weggerissen — die Kundin
   sähe die Bestätigung nie. Im <body> übersteht es den Austausch; der frisch
   gerenderte Auslöser wird danach an dasselbe Fenster gehängt (gleiches Muster
   wie beim facets-drawer, siehe Memory `reference_prestige_drawer_teleport`).
--------------------------------------------------------------------------- */
(function () {
  /* Überlebt den Rerender: das ausgelagerte Fenster und die Felder darin. */
  var fenster = null;
  /* Zeigt immer auf die AKTUELL gerenderte Auslöser-Zeile — dort stehen die
     Einstellungen und die Texte, und die kommen nach jedem Rerender neu. */
  var wurzel = null;

  /* 🔴 Die Zuordnung (Lennart, 23.10.2026). Anker ist die KONFEKTIONSGRÖSSE im
     OBERTEIL, nicht die Körpergröße:
         XS, S  bis 175 cm -> kurz,  ab 176 -> lang
         M      bis 169 cm -> kurz,  ab 170 -> lang
         L, XL, XXL        -> lang, unabhängig von der Körpergröße
     Deshalb eine Schwellen-Tabelle "bis zu welcher Körpergröße ist diese
     Konfektionsgröße noch kurz" (0 = nie kurz) und keine Grenze plus Ausnahmen.
     Ein Widerspruchsfall kann so nicht mehr entstehen.

     Beide Angaben sind im Formular Pflicht. Die Funktion bleibt trotzdem
     tolerant und antwortet mit `null`, statt bei einer fehlenden Angabe zu raten
     — zweite Linie hinter dem `required`, falls das Formular je umgebaut wird. */
  function auswerten(groesse, konfektion) {
    var tabelle;
    try { tabelle = JSON.parse(wurzel.dataset.regeln || '{}'); } catch (_) { return null; }
    if (!konfektion) return null;
    var maxKurz = tabelle[konfektion.trim().toUpperCase()];
    if (typeof maxKurz !== 'number') return null;
    if (maxKurz <= 0) return 'lang';
    if (groesse && groesse > maxKurz) return 'lang';
    return 'kurz';
  }

  /* Produktseite: gezielt das Radio der Längen-Option. */
  function pdpSetzen(wahl) {
    var formId = wurzel.dataset.formId;
    var position = wurzel.dataset.optionPosition;
    var wert = wurzel.dataset[wahl === 'lang' ? 'wertLang' : 'wertKurz'];
    if (!formId || !position || !wert) return false;
    var ziel = document.querySelector(
      'input[form="' + formId + '"][data-option-position="' + position + '"][value="' + wert + '"]'
    );
    if (!ziel) return false;
    if (ziel.disabled) return 'nicht_verfuegbar';
    if (!ziel.checked) {
      ziel.checked = true;
      ziel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  /* 🔴 Story-/Sales-Seite: hier gibt es keine Variantenauswahl, sondern den
     2+1-Konfigurator (snippets/dhb-hk-schritt.liquid). Jede Handykette-Karte hat
     einen Kurz/Lang-Umschalter `.gf-lvar`; Kurz ist voreingestellt (`an`).

     🔴 Der Umschalter darf NICHT blind angeklickt werden: sein Klick-Listener in
     sections/dhb-hk-story.liquid waehlt die Karte gleich mit aus (aria-checked,
     wahl[schritt], Preisleiste). Ein Klick auf alle Karten wuerde der Kundin also
     drei Produkte ins Bundle legen, die sie nie angetippt hat. Deshalb:

       Karte schon gewaehlt -> echter Klick, damit die Section ihre eigene
           Auswahl samt Preis mitbekommt (sie bleibt dieselbe Karte, nur andere
           Laenge).
       Karte nicht gewaehlt -> nur die Voreinstellung umlegen, ohne Klick. Tippt
           sie die Karte spaeter an, nimmt sie die richtige Laenge mit.

     Rueckgabe: true, wenn mindestens ein Umschalter gefunden wurde (auf
     page.hk_sales ist kein Konfigurator gesetzt, dann bleibt es bei der
     Empfehlung plus Weiter-Link). */
  function beratungSetzen(wahl) {
    var gefunden = 0;
    [].forEach.call(document.querySelectorAll('.gf-karte'), function (karte) {
      var schalter = karte.querySelectorAll('.gf-lvar');
      if (schalter.length < 2) return;
      var ziel = null;
      [].forEach.call(schalter, function (s) {
        var istLang = /lang/i.test(s.textContent);
        if (istLang === (wahl === 'lang')) ziel = s;
      });
      if (!ziel) return;
      gefunden++;
      if (ziel.classList.contains('an')) return;
      if (karte.getAttribute('aria-checked') === 'true') {
        ziel.click();
      } else {
        [].forEach.call(schalter, function (s) { s.classList.remove('an'); });
        ziel.classList.add('an');
        if (ziel.dataset.vid) karte.dataset.vid = ziel.dataset.vid;
        if (ziel.dataset.preis) karte.dataset.preis = ziel.dataset.preis;
        if (ziel.dataset.name) karte.dataset.name = ziel.dataset.name;
      }
    });
    return gefunden > 0;
  }

  function zu() {
    if (!fenster) return;
    if (typeof fenster.el.close === 'function' && fenster.el.open) fenster.el.close();
    else fenster.el.removeAttribute('open');
  }

  function auf() {
    if (!fenster) return;
    fenster.fehler.textContent = '';
    fenster.ergebnis.hidden = true;
    if (fenster.weiter) fenster.weiter.hidden = true;
    if (fenster.senden) fenster.senden.hidden = false;
    if (fenster.abbruch) {
      fenster.abbruch.textContent = fenster.urtextAbbruch;
      fenster.abbruch.classList.remove('hkf__abbruch--fertig');
    }
    /* showModal() bringt Escape, Fokusfalle und Hintergrund-Sperre vom Browser
       mit — genau das, was beim Gewinnrad von Hand fehlte. */
    if (typeof fenster.el.showModal === 'function') fenster.el.showModal();
    else fenster.el.setAttribute('open', '');

    /* 🔴 Fokus auf die Ueberschrift, nicht aufs erste Feld. Ohne das setzt
       showModal() ihn auf das Groessen-Feld, und auf dem Handy klappt die
       Auswahlliste beim Oeffnen sofort auf (Lennart, 23.10.2026). Im Markup steht
       dafuer schon `autofocus`; das hier ist der Nachsetzer, weil Safari
       `autofocus` auf einem Nicht-Formularelement unzuverlaessig behandelt und
       dann wieder beim Feld landen wuerde — genau auf der Plattform, auf der es
       am meisten stoert. */
    if (fenster.titel && typeof fenster.titel.focus === 'function') {
      try { fenster.titel.focus({ preventScroll: true }); } catch (_) { fenster.titel.focus(); }
    }
  }

  function absenden(e) {
    e.preventDefault();
    if (!wurzel || !fenster) return;
    var d = wurzel.dataset;
    var groesse = parseInt(fenster.groesse.value, 10);
    var konfektion = fenster.konfektion.value;

    if (!konfektion || !groesse) { fenster.fehler.textContent = d.textFehlendeAngabe; return; }
    if (groesse && (groesse < 120 || groesse > 220)) { fenster.fehler.textContent = d.textGroesseUnplausibel; return; }

    var wahl = auswerten(groesse, konfektion);
    if (!wahl) { fenster.fehler.textContent = d.textFehlendeAngabe; return; }

    var name = d[wahl === 'lang' ? 'nameLang' : 'nameKurz'];
    /* 🔴 Nach einem Treffer bleibt das Fenster offen, bis die Kundin es selbst
       zumacht (Lennart, 23.10.2026: "damit er auch seine Groesse sieht"). Vorher
       ging es auf der Produktseite nach 1,6 Sekunden von allein zu — die
       Empfehlung war damit genau so lange zu sehen, wie man braucht, um sie zu
       uebersehen. Statt des Zeitgebers wird das Absenden ausgeblendet und aus
       "Abbrechen" ein "Fertig": es gibt nach dem Treffer nichts mehr abzubrechen,
       nur noch zu lesen und zu schliessen. */
    function sage(vorlage) {
      fenster.fehler.textContent = '';
      fenster.ergebnis.textContent = (vorlage || '').replace('{laenge}', name);
      fenster.ergebnis.hidden = false;
      if (fenster.senden) fenster.senden.hidden = true;
      if (fenster.abbruch) {
        fenster.abbruch.textContent = d.textFertig || 'Fertig';
        fenster.abbruch.classList.add('hkf__abbruch--fertig');
      }
    }

    if (d.modus === 'beratung') {
      var imKonfigurator = beratungSetzen(wahl);
      /* Andere Seiten ohne `.gf-karte` (z. B. sections/dhb-crew.liquid) hoeren
         auf dieses Ereignis und setzen ihre eigene Auswahl. `gesetzt` wird
         von dort synchron auf true gestellt, wenn etwas umgestellt wurde. */
      var meldung = { wahl: wahl, gesetzt: false };
      document.dispatchEvent(new CustomEvent('dhb:hk-laenge', { detail: meldung }));
      imKonfigurator = imKonfigurator || meldung.gesetzt;
      sage(imKonfigurator ? (d.textErgebnisGesetzt || d.textErgebnis) : d.textErgebnis);
      /* Dazu der Weiter-Link: hier ist die Empfehlung selbst das Ergebnis, und
         der Link ist der naechste Schritt — in den Konfigurator oder in die
         Kollektion, je nach Seite. */
      if (fenster.weiter && d.ziel) {
        fenster.weiter.href = d.ziel;
        fenster.weiter.textContent = d.textWeiter || 'Weiter';
        fenster.weiter.hidden = false;
      }
      return;
    }

    var gesetzt = pdpSetzen(wahl);
    if (gesetzt === 'nicht_verfuegbar') { fenster.fehler.textContent = d.textAusverkauft; return; }
    if (!gesetzt) { fenster.fehler.textContent = d.textFehler.replace('{laenge}', name); return; }

    sage(d.textErgebnis);
  }

  function auslagern(el) {
    document.body.appendChild(el);
    fenster = {
      el: el,
      form: el.querySelector('[data-hkf-form]'),
      groesse: el.querySelector('[data-hkf-groesse]'),
      konfektion: el.querySelector('[data-hkf-konfektion]'),
      ergebnis: el.querySelector('[data-hkf-ergebnis]'),
      fehler: el.querySelector('[data-hkf-fehler]'),
      weiter: el.querySelector('[data-hkf-weiter]'),
      senden: el.querySelector('[data-hkf-senden]'),
      titel: el.querySelector('.hkf__titel'),
      abbruch: el.querySelector('[data-hkf-schliessen]')
    };
    if (fenster.abbruch) fenster.urtextAbbruch = fenster.abbruch.textContent;
    if (!fenster.form) { fenster = null; return false; }
    fenster.form.addEventListener('submit', absenden);
    el.querySelectorAll('[data-hkf-schliessen]').forEach(function (b) {
      b.addEventListener('click', zu);
    });
    return true;
  }

  function verdrahten(neueWurzel) {
    wurzel = neueWurzel;
    var eigenesFenster = neueWurzel.querySelector('[data-hkf-dialog]');

    if (!fenster) {
      if (!eigenesFenster || !auslagern(eigenesFenster)) return;
    } else if (eigenesFenster) {
      /* Nach einem Rerender liefert der Server ein zweites, leeres Fenster mit.
         Das muss weg, sonst liegen zwei im DOM und der Auslöser öffnet das
         falsche (ohne Listener). */
      eigenesFenster.remove();
    }

    if (neueWurzel.dataset.bereit === '1') return;
    neueWurzel.dataset.bereit = '1';
    var oeffnen = neueWurzel.querySelector('[data-hkf-oeffnen]');
    if (oeffnen) oeffnen.addEventListener('click', auf);
  }

  function start() {
    var el = document.querySelector('[data-hk-laengenfinder]');
    if (el) verdrahten(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* 🔴 Die Variantenauswahl rendert den Block neu (Section Rendering API), der
     Auslöser kommt dabei frisch aus dem Server — danach erneut verdrahten. */
  document.addEventListener('variant:change', start);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      /* Im Theme-Editor wird die ganze Section ersetzt; das ausgelagerte Fenster
         wäre dann eine Leiche aus dem alten Baum. */
      if (fenster) { fenster.el.remove(); fenster = null; }
      start();
    });
  }
})();
